<ng-container *ngIf="internalConfig?.data">
    <div class="blinds-bar"></div>
    <div class="sh-page-header sh-sticky-header --sh-background-color" style="padding-bottom: 1rem">
        @if (prevNav || nextNav || internalConfig.data.prevAction || internalConfig.data.nextAction || indexTitle) {
            <nav class="sh-page-header__navigation">
                <div class="image-viewer-header">
                    <div class="place-left">
                        @if (prevNav) {
                            <a
                                class="sh-link sh-icon-link sh-action-bar__group__item"
                                [routerLink]="prevNav"
                                [state]="internalConfig.data.state"
                                [relativeTo]="route"
                            >
                                <ng-container *ngTemplateOutlet="previous"></ng-container>
                            </a>
                        }

                        @if (internalConfig.data.prevAction) {
                            <a class="sh-link sh-icon-link sh-action-bar__group__item" (click)="internalConfig.data.prevAction()">
                                <ng-container *ngTemplateOutlet="previous"></ng-container>
                            </a>
                        }
                    </div>

                    <div class="place-right">
                        @if (nextNav) {
                            <a
                                class="sh-link sh-icon-link sh-action-bar__group__item"
                                [routerLink]="nextNav"
                                [state]="internalConfig.data.state"
                                [relativeTo]="route"
                            >
                                <ng-container *ngTemplateOutlet="next"></ng-container>
                            </a>
                        }

                        @if (internalConfig.data.nextAction) {
                            <a class="sh-link sh-icon-link sh-action-bar__group__item" (click)="internalConfig.data.nextAction()">
                                <ng-container *ngTemplateOutlet="next"></ng-container>
                            </a>
                        }
                    </div>

                    @if (indexTitle) {
                        <span>
                            {{ indexTitle }}

                            @if (contextRecordName) {
                                <b>{{ contextRecordName }}</b>
                            }
                        </span>
                    }
                </div>
            </nav>
        }

        @if (recordTitle || recordActions) {
            <header class="sh-page-header__head">
                @if (recordTitle) {
                    <a
                        class="sh-page-header__head__info sh-truncate-text sh-page-title--small-subsection sh-link sh-truncate-text"
                        [title]="recordTitle"
                        (click)="navigateToDetailPage()"
                    >
                        {{ recordTitle }}
                    </a>
                }

                @if (recordActions) {
                    <div class="sh-page-header__head__actions">
                        <div class="sh-action-group -sh-condense">
                            @for (item of recordActions; track item.label) {
                                <sh-action-item [item]="item" class="sh-action-group__item"></sh-action-item>
                            }
                        </div>
                    </div>
                }
            </header>
        }
    </div>

    @if (showImageView) {
        @if (record?.isPlayableMedia()) {
            <div class="video-container">
                <med-media-player [record]="record"></med-media-player>
            </div>
        } @else if (isDocument) {
            <sh-document-viewer [record]="record" [rotate]="true"></sh-document-viewer>
        }
        @else {
            <sh-image-viewer [imageSources]="[internalConfig.data.fragmentPreviewUrl]" [rotate]="true"></sh-image-viewer>
        }
    } @else {
        <ng-container *ngTemplateOutlet="placeholder"></ng-container>
    }
</ng-container>

<ng-template #previous>
    <svg sh-icon class="sh-icon--small sh-icon-link__icon -sh-align-start" [name]="'angle-left'"></svg>
    {{ "components.pagination.previous-result" | translate }}
</ng-template>

<ng-template #next>
    {{ "components.pagination.next-result" | translate }}
    <svg sh-icon class="sh-icon--small sh-icon-link__icon -sh-align-end" [name]="'angle-right'"></svg>
</ng-template>

<ng-template #placeholder>
    <figure class="sh-media-with-overlay">
        <sh-media-placeholder style="width: 30rem" [showMessage]="true" [spinning]="isLoading" [message]="placeholderMessage"></sh-media-placeholder>
    </figure>
</ng-template>

<sh-toast-container [toasts]="toasts$ | async" (closeToast)="closeToast($event)"></sh-toast-container>
